import React, { useMemo } from 'react'
import { Trans, useTranslation, WithTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiInfo } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { useSelector } from 'react-redux'
import { getActiveLicense } from '../../../../../reducers/userAccount/selectors/license'
import { LicenseType } from '../../../../../models/License'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { getUserPriceGroup } from '../../../../../reducers/userAccount/selectors/userAccount'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import { getPanelUrlForEnv } from '../../../../../utils/ApiUrl'
import { getAccessToken } from '../../../../../reducers/userAccount/selectors/credentials'
import { Mixpanel } from '../../../../../utils/Mixpanel'

function Help({
  size = 1,
  className,
  isSidebarOpen,
}: IHelpProps & IWithSize & WithTranslation) {
  const { t } = useTranslation()
  const [isOpen, toggleOpen] = React.useState(false)
  const licenseValid = useSelector(getActiveLicense)
  const userPriceGroup = +useSelector(getUserPriceGroup)
  const key = useSelector(getAccessToken)

  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })

  const isDetailedMenu = useMemo(
    () => scopes.premium &&
      [
        LicenseType.LICENSE_PREMIUM_PLUS,
        LicenseType.LICENSE_PREMIUM_PRO,
        LicenseType.LICENSE_PREMIUM_MAX,
      ].includes(licenseValid?.licenseType),
    [licenseValid, scopes],
  )

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  const onClick = () => {
    window.open(t('BED_3604_knowlegde_base_link'), '__blank')
  }
  const onBuyAssistClick = (e) => {
    e.preventDefault()
    Mixpanel.track("Setup Assistant Menu Item Used",{})
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/buy/assist`
  }

  return isDetailedMenu && userPriceGroup === 3 ? (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          className={`${className}-button-expand`}
          nested={true}
        >
          <b>
            <FiInfo size={16 * size} />
          </b>
          <Label primary={true} size={size} className={`${className}-label`}>
            <Trans i18nKey={'title_activity_help'}>Pomoc</Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList
            size={size}
            nested={true}
            style={{ maxHeight: 'var(--full)' }}
          >
            <SmartLink
              size={size}
              activeClassName={'active'}
              nested={true}
              to={'/help'}
              onClick={onClick}
            >
              <MenuElement size={size} alignCenter={true}>
                <Flex alignCenter full>
                  {t('BED_16430_help_center')}
                </Flex>
              </MenuElement>
            </SmartLink>

            <SmartLink
              size={size}
              activeClassName={'active'}
              nested={true}
              to={'/buy/assist'}
              onClick={onBuyAssistClick}
            >
              <MenuElement size={size} alignCenter={true}>
                <Flex alignCenter full>
                  {t('BED_28970_setup_help')}
                </Flex>
              </MenuElement>
            </SmartLink>
          </MenuList>
        )}
      </MenuElement>
    </>
  ) : (
    <MenuElement size={size} alignCenter={true}>
      <Link to={'/help'} onClick={onClick} size={size}>
        <Flex alignCenter={true}>
          <b>
            <FiInfo size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            <Trans i18nKey={'title_activity_help'}>Pomoc</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export interface IHelpProps {
  className?: string
  isSidebarOpen: boolean
}

export default Help
